import {
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

import { ReactComponent as IconSave } from "../../../../images/iconSave.svg";

import Item from "../Item";

export default function Condutas({ data, small }) {
  return (
    <Accordion defaultExpanded={false} className="AccordionContainer">
      <AccordionSummary
        expandIcon={<ExpandMore style={{ color: "#1E729F" }} />}
        aria-controls="Condutas-content"
        id="Condutas-header"
        className={`AccordionSummaryContainer ${small ? "small" : ""}`}
      >
        <Stack direction="row" alignItems="center" gap="8px " height="30px">
          <IconSave style={{ width: "24px" }} />
          <Typography className={`Accordion_title ${small ? "small" : ""}`}>
            Condutas
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Item
          label="Conduta, conclusões e encaminhamentos"
          text={data.condutaConclusaoEncaminhamentos}
        />
      </AccordionDetails>
    </Accordion>
  );
}
